const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://webyoufirst.fr';
const PHONE    = process.env.REACT_APP_PHONE   || '+33XXXXXXXXX';
const EMAIL    = process.env.REACT_APP_EMAIL   || 'contact@webyoufirst.fr';

export const generateWebSiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  'url': SITE_URL,
  'name': 'WEB YOU FIRST',
  'description': 'Agence Web dans les Yvelines — création React, SEO local, Google Ads.',
  'inLanguage': 'fr-FR',
  'publisher': {
    '@id': `${SITE_URL}/#organization`
  },
  'potentialAction': {
    '@type': 'SearchAction',
    'target': {
      '@type': 'EntryPoint',
      'urlTemplate': `${SITE_URL}/?s={search_term_string}`
    },
    'query-input': 'required name=search_term_string'
  }
});

export const generateLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#organization`,
  'name': 'WEB YOU FIRST',
  'url': SITE_URL,
  'logo': `${SITE_URL}/assets/logo.png`,
  'image': `${SITE_URL}/og-image.jpg`,
  'description': 'Agence Web dans les Yvelines spécialisée en création de sites React sur-mesure, SEO local et acquisition Google Ads.',
  'telephone': PHONE,
  'email': EMAIL,
  'priceRange': '€€',
  'address': {
    '@type': 'PostalAddress',
    'streetAddress': "Bois-d'Arcy",
    'addressLocality': "Bois-d'Arcy",
    'postalCode': '78390',
    'addressRegion': 'Île-de-France',
    'addressCountry': 'FR'
  },
  'geo': {
    '@type': 'GeoCoordinates',
    'latitude': 48.8020,
    'longitude': 2.0163
  },
  'openingHoursSpecification': {
    '@type': 'OpeningHoursSpecification',
    'dayOfWeek': ['Monday','Tuesday','Wednesday','Thursday','Friday'],
    'opens': '09:00',
    'closes': '18:00'
  },
  'areaServed': {
    '@type': 'AdministrativeArea',
    'name': 'Yvelines'
  },
  'aggregateRating': {
    '@type': 'AggregateRating',
    'ratingValue': '5',
    'bestRating': '5',
    'worstRating': '1',
    'ratingCount': '12'
  },
  'sameAs': [
    'https://www.linkedin.com/company/web-you-first',
    'https://www.facebook.com/webyoufirst'
  ]
});

export const generateServiceSchema = (serviceName, description, url = null) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  'serviceType': serviceName,
  'name': serviceName,
  'description': description,
  ...(url && { 'url': `${SITE_URL}${url}` }),
  'provider': {
    '@type': 'ProfessionalService',
    '@id': `${SITE_URL}/#organization`,
    'name': 'WEB YOU FIRST',
    'url': SITE_URL
  },
  'areaServed': [
    { '@type': 'State', 'name': 'Yvelines' },
    { '@type': 'City', 'name': 'Versailles' },
    { '@type': 'City', 'name': 'Saint-Germain-en-Laye' }
  ]
});

export const generateFAQSchema = (faqs) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqs.map(faq => ({
      '@type': 'Question',
      'name': faq.question,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.answer
      }
    }))
  };
};

export const generateBreadcrumbSchema = (items) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': items.map((item, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': item.name,
      'item': item.url
    }))
  };
};

export const generateReviewSchema = (reviews) => {
  return reviews.map(review => ({
    '@context': 'https://schema.org',
    '@type': 'Review',
    'author': {
      '@type': 'Person',
      'name': review.author
    },
    'reviewRating': {
      '@type': 'Rating',
      'ratingValue': review.rating,
      'bestRating': '5'
    },
    'reviewBody': review.text
  }));
};
